import { lazy, Suspense, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Fade, Tooltip } from '@mui/material';
import { Group as GroupIcon } from '@mui/icons-material';

import { currentModuleToolkit } from '/store/toolkits';
import { useModal } from '/hooks';

import { BadgeStyled, ButtonStyled } from './styles';

const OnlineUsersDialog = lazy(() =>
  import(/* webpackChunkName: "OnlineUsersDialog" */ './OnlinePageUsersDialog').then((module) => ({
    default: module.OnlineUsersDialog,
  }))
);
export const OnlinePageUsers = () => {
  const users = useSelector(currentModuleToolkit.selectors.selectModuleUsers);
  const { open, isOpen, close } = useModal();

  const [usersLength, setUsersLength] = useState<number>(0);

  useEffect(() => {
    if (users.length !== 0) {
      setUsersLength(users.length);
    }
  }, [users.length]);

  const noUsers = users.length === 0;
  const allUsersAway = users.every((user) => user.away);

  return (
    <>
      <Fade in={!noUsers}>
        <Tooltip title='View all users' placement='bottom'>
          <ButtonStyled onClick={open} color='inherit'>
            <BadgeStyled
              $away={allUsersAway}
              invisible={noUsers}
              variant='dot'
              anchorOrigin={{
                horizontal: 'left',
                vertical: 'bottom',
              }}
            >
              <GroupIcon />
            </BadgeStyled>
            {usersLength}
          </ButtonStyled>
        </Tooltip>
      </Fade>

      {isOpen && (
        <Suspense>
          <OnlineUsersDialog onClose={close} users={users} />
        </Suspense>
      )}
    </>
  );
};
